import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
  {
    num: "01",
    title: "Tecnología de vanguardia",
    text: "Equipos de ecografía de alta definición y laboratorio automatizado para diagnósticos precisos.",
  },
  {
    num: "02",
    title: "Precisión diagnóstica",
    text: "Cada estudio es revisado con rigor médico para entregarte resultados claros y confiables.",
  },
  {
    num: "03",
    title: "Trato humano",
    text: "Te acompañamos en cada etapa con calidez, paciencia y explicaciones sencillas.",
  },
];

const About = () => (
  <section
    id="nosotros"
    data-testid="about-section"
    className="relative overflow-hidden bg-white py-24 sm:py-32"
  >
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-2">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="relative"
      >
        <div className="overflow-hidden rounded-[2rem]">
          <img
            data-testid="about-image"
            src="/assets/dra-lixandra.jpg"
            alt="Dra. Lixandra García Peña, ECOCORE DX"
            className="aspect-[4/5] w-full object-cover object-top transition-transform duration-700 hover:scale-105"
          />
        </div>
        <div
          data-testid="about-doctor-caption"
          className="absolute bottom-6 left-6 rounded-2xl border border-white/40 bg-white/85 px-5 py-3 shadow-lg backdrop-blur-xl"
        >
          <p className="font-display text-base font-semibold text-slate-900">
            Dra. Lixandra García Peña
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-red-600">
            ECOCORE DX Ecografía y Diagnóstico
          </p>
        </div>
        <div
          data-testid="about-badge"
          className="absolute -bottom-12 right-2 rounded-2xl border border-slate-200 bg-white px-6 py-4 shadow-xl sm:right-6"
        >
          <p className="font-display text-3xl font-semibold text-red-600">
            100%
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            Compromiso con tu salud
          </p>
        </div>
      </motion.div>

      <div>
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-red-700">
            02 — Nosotros
          </p>
          <h2 className="mt-4 font-display text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
            Un centro de diagnóstico pensado para tu tranquilidad
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            En ECOCORE DX combinamos tecnología diagnóstica moderna con una
            atención cercana. Sabemos que detrás de cada ecografía y cada
            análisis hay una persona, una familia y una historia que importa.
          </p>
        </motion.div>

        <div className="mt-10 space-y-0">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: EASE }}
              data-testid={`about-chapter-${c.num}`}
              className="group flex gap-6 border-t border-slate-200 py-6 last:border-b"
            >
              <span className="font-mono text-xs tracking-[0.3em] text-red-700">
                {c.num}
              </span>
              <div>
                <h3 className="font-display text-lg font-medium text-slate-900 transition-colors duration-300 group-hover:text-red-700">
                  {c.title}
                </h3>
                <p className="mt-1 text-sm leading-relaxed text-slate-600">
                  {c.text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default About;
